import { styled } from 'styled-components';

import { defaultSettingsHtml, mq } from '@/shared/ui/styled';

export const StyledTabDescriptionTitle = styled.div`
    ${defaultSettingsHtml};
`;

export const StyledabDescriptiontList = styled.ul`
    padding-top: 15px;
`;

export const StyledabDescriptiontListItem = styled.li`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-left: 15px;

    &::before {
        content: '•';
        color: #000;
        width: 10px;
        margin-right: 5px;
    }

    ${mq.md} {
        font-size: 16px;
        line-height: 19.2px;
    }
`;
